import React from 'react';
import styles from './CoreCover.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { Container, Image } from '@/components';

let cx = className.bind(styles);

export default function CoreCover(props) {
	const { attributes, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];
	var contentPosition = attributes.contentPosition?.split(' ') || [];
	const minHeightUnit = attributes.minHeightUnit ? attributes.minHeightUnit : 'px';
	const minHeight = attributes.minHeight ? `${attributes.minHeight}${minHeightUnit}` : null;
	const coverStyles = {
		minHeight: minHeight,
	};
	const overlayStyles = {
		opacity: `${attributes.dimRatio * .01}`,
		backgroundColor: attributes.customOverlayColor,
	};
	const focalPoint = JSON.parse(attributes.focalPoint);

	function InnerBlocks() {
		return <div className={cx(['ns_cover-content', 'cover-content'])}>{React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}</div>;
	}

	return React.createElement(
		attributes.tagName,
		{ id: attributes.anchor, className: cx(['ns_cover', 'cover', ...className, attributes.textColor && `text-color-${attributes.textColor}`, attributes.isDark && 'is-dark', contentPosition.length > 0 && `content-pos-${contentPosition[0]}-${contentPosition[1]}`, attributes.align && `align-${attributes.align}`]), style: Object.keys(coverStyles).length > 0 && coverStyles },
		<>
			{attributes.tagName === 'section' && attributes.align !== 'full' ? (
				<Container>
					<InnerBlocks />
				</Container>
			) : (
				<InnerBlocks />
			)}
			{(attributes.overlayColor || attributes.customOverlayColor) && <div className={cx(['overlay', attributes.overlayColor && `bg-${attributes.overlayColor}`])} style={overlayStyles} />}
			{attributes.backgroundType === 'image' && attributes.url && <Image className={cx('cover-image')} alt={attributes.alt || ''} src={attributes.url} fill={true} objectFit="cover" objectPosition={`${focalPoint?.x * 100}% ${focalPoint?.y * 100}%`} />}
		</>
	);
}

CoreCover.fragments = {
	key: `CoreCoverFragment`,
	entry: gql`
		fragment CoreCoverFragment on CoreCover {
			attributes {
        align
				anchor
				alt
				backgroundType
				className
        contentPosition
				customOverlayColor
				dimRatio
				focalPoint
				isDark
				minHeight
				minHeightUnit
				overlayColor
				tagName
				url
        textColor
			}
		}
	`,
};

CoreCover.config = {
	name: 'CoreCover',
};
CoreCover.displayName = 'CoreCover';
